module.exports = __webpack_public_path__ + "static/img/shuziyingxiao_07.67ad5f5b.jpg";